import { render, staticRenderFns } from "./OnboardingUsers.vue?vue&type=template&id=0cb39275&scoped=true"
import script from "./OnboardingUsers.vue?vue&type=script&lang=js"
export * from "./OnboardingUsers.vue?vue&type=script&lang=js"
import style0 from "./OnboardingUsers.vue?vue&type=style&index=0&id=0cb39275&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb39275",
  null
  
)

export default component.exports